import React, { useEffect, useState } from 'react';
import { Modal, Select, Form, Button, message } from 'antd';
import { useGlobalState } from '../../../store/state';
import { GetInfluencerLists } from '../../../apis/Brand/InfluencerList/GetInfluencerLists';
import { Link } from 'react-router-dom';
import PlatformIconRender from '../../Common/PlatformIconRender';
import { AddInfluencerToList } from '../../../apis/Brand/Discovery/AddInfluencerToList';

const { Item } = Form;
const { Option } = Select;
const AddInfluencerToListModal = ({
  visible,
  onOk,
  onCancel,
  influid,
  firstname,
  lastname,
  platform,
}) => {
  const [user]= useGlobalState('user');
  const [company]= useGlobalState('company');
  const [avlList, setAvlList] = useState([]);

  useEffect(() => {
    let unmounted = false;
    setAvlList([]);
    GetInfluencerLists(user.accessToken, company.selected.id).then(({ status, response })=>{
      if (status === 200 && !unmounted) {
        // note: pick only carries particular platform name
        const _filtered = [];
        response.list.map((obj) =>{
          if (obj.platform === platform) {
            _filtered.push(obj);
          }
        });
        setAvlList([
          ..._filtered,
        ]);
      }
    });
    return () => {
      unmounted = true;
    };
  }, [platform]);

  const onSaveToList = ({ saveList }) =>{
    const _data = {
      influencerid: influid,
      brand: company.selected.id,
      listid: saveList,
    };

    // console.log("values",_data)
    AddInfluencerToList(user.accessToken, _data).then(({ status, response })=>{
      // console.log("response",response)
      if (status === 200) {
        message.success(`${firstname} ${lastname} added to selected list`);
      } else {
        message.error(`There is some issue while adding to list`);
      }
    });
  };
  return (
    <Modal
      title={<>Add <i>{firstname} {lastname}</i> to your list</>}
      visible={visible}
      onOk={onOk}
      okText="Completed"
      onCancel={onCancel}
      destroyOnClose={true}
    >
      <Form
        name="addInfluToList"
        onFinish={onSaveToList}
      >
        <h6><strong>Save In</strong></h6>
        <Item
          name="saveList"
        >
          <Select placeholder="Please select a list"
            className="common_select"
            size="large">
            {avlList.map(({ listname, platform, _id })=>(
              <Option key={_id}
                value={_id}><PlatformIconRender platform={platform}/> {listname}</Option>
            ))}
          </Select>
        </Item>
        <Item>
          <Button htmlType='submit'
            className="common_button outlined small py-2">Save to this list</Button>
          <span className="ml-3">or</span>
          <Link to={`/brand/${company.selected.id}/influencer-list`}>
            <Button type="link">Create a new List</Button>
          </Link>
        </Item>
      </Form>
    </Modal>
  );
};

export default AddInfluencerToListModal;
